import { render, staticRenderFns } from "./examRecord.vue?vue&type=template&id=18a4bfbf&scoped=true&"
import script from "./examRecord.vue?vue&type=script&lang=js&"
export * from "./examRecord.vue?vue&type=script&lang=js&"
import style0 from "./examRecord.vue?vue&type=style&index=0&id=18a4bfbf&lang=scss&scoped=true&"
import style1 from "./examRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4bfbf",
  null
  
)

export default component.exports